<template>
    <div v-if="isLoaded">
        <b-card style="border:none;">
            <b-container>
                <b-row align-h="between" class="mt-4">
                    <b-col cols="4">
                        <h5 style="display:inline;">{{ $t('groupName') }}</h5>
                        <template v-if="groupType != null">
                            <b-form-input
                                :disabled="true"
                                @change="isChanged = true"
                                id="username"
                                :placeholder="$t(this.getGroupName(groupName))"
                            ></b-form-input>
                        </template>
                        <template v-else>
                            <b-form-input
                                :disabled="groupType === 'admin'"
                                @change="isChanged = true"
                                id="username"
                                v-model="groupName"
                                :placeholder="$t('groupName')"
                            ></b-form-input>
                        </template>
                    </b-col>
                    <b-col cols="4">
                        <span v-if="groupType === 'admin'" style="top:50%;position: absolute;"
                            ><b>({{ $t('thisGroupCanNotBeEdit') }})</b></span
                        >
                    </b-col>
                    <b-col class="text-right" cols="4">
                        <b-button @click="save()" variant="success">{{ $t('save') }}</b-button>
                        <b-button v-if="isEditPage && groupType !== 'admin'" @click="deleteGroup()" class="ml-3" variant="danger">{{
                            $t('delete')
                        }}</b-button>
                    </b-col>
                </b-row>
                <h2 class="mt-4" style="text-align: left;">{{ $t('permissions') }}</h2>
                <b-row>
                    <br />
                    <b-col>
                        <b-card border-variant="secondary" style="border:none;" v-for="group in Object.keys(permissions)" :key="group">
                            <div>
                                <div style="text-align: left;">
                                <b-form-checkbox
                                    :disabled="groupType === 'admin' || allPermissions[group].disabled"
                                    v-model="allPermissions[group].value"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    @change="
                                        permissionGroupSelected($event, group);
                                        isChanged = true;
                                    "
                                >
                                    <b>{{ $t(`${group}`) }}</b>
                                </b-form-checkbox>
                                </div>
                                <b-row class="ml-4 mt-2 mb-3">
                                    <b-col cols="4" class="text-left" v-for="permission in Object.keys(permissions[group])" :key="permission">
                                        <b-form-checkbox
                                            :disabled="groupType === 'admin' || permissions[group][permission].disabled"
                                            v-model="permissions[group][permission].value"
                                            name="checkbox-1"
                                            :value="true"
                                            :unchecked-value="false"
                                            @input="permissionSelected($event, group)"
                                            @change="isChanged = true"
                                        >
                                            {{ $t(`${permission}`) }}
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <h2 class="mt-4" style="text-align: left;">{{ $t('users') }}</h2>

                <b-row>
                    <b-col style="width:100%;">
                        <b-card border-variant="info" style="border:none;">
                            <!--
                            <el-transfer
                                style="text-align: left;"
                                v-model="selectedUsers"
                                :titles="[$t('allUsers'), $t('selectedUsers')]"
                                filterable
                                :props="{
                                    key: 'id',
                                    label: 'label'
                                }"
                                :format="{
                                    noChecked: '${total}',
                                    hasChecked: '${checked}/${total}'
                                }"
                                :data="allUsers"
                                :filter-placeholder="$t('searchUsers')"
                                @left-check-change="isChanged = true"
                                @right-check-change="isChanged = true"
                            >
                            </el-transfer>
                            -->
                            <transfer
                            :options="allUsers"
                            :selected="selectedUsers"
                            :sourceTitle="$t('allUsers')"
                            :targetTitle="$t('selectedUsers')"
                            :searchPlaceholder="$t('searchUsers')"
                            @onChange="setSelectedUsers"
                            >
                            </transfer>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash';
import Transfer from '../../components/Transfer.vue';
export default {
    name: 'PermissionEdit',
    components: { Transfer },
    data() {
        return {
            groupId: null,
            groupName: '',
            originalName: '',
            permissions: {
                dataPermissions: {
                    canViewData: {value:false, disabled:false},
                    canEditData: {value:false, disabled:false},
                    canAddDatatype: {value:false, disabled:false}
                },
                targetPermissions: {
                    canCreateGlobalGoals: {value:false, disabled:false},
                    canCreateGoals: {value:false, disabled:false},
                    canEditGoals: {value:false, disabled:false},
                    canApproveGoals: {value:false, disabled:false}
                },
                auditPermissions: {
                    canStartAudits: {value:false, disabled:false},
                    canReplyToAudits: {value:false, disabled:false},
                    canCreateAudit: {value:false, disabled:false}
                },
                documentPermissions: {
                    canUploadDocuments: {value:false, disabled:false}
                },
                reportPermissions: {
                    canGetReport: {value:false, disabled:false}
                },
                generalPermissions: {
                    canViewComparisons: {value:false, disabled:false},
                    canSeeAllLocations: {value:false, disabled:false},
                    isAdmin: {value:false, disabled:false}
                }
            },
            allPermissions: {
                dataPermissions: {value:false, disabled:false},
                targetPermissions: {value:false, disabled:false},
                auditPermissions: {value:false, disabled:false},
                documentPermissions: {value:false, disabled:false},
                generalPermissions: {value:false, disabled:false},
                reportPermissions: {value:false, disabled:false}
            },
            selectedUsers: [],
            isAddPage: false,
            isChanged: false,
            groupType: null,
            isEditPage: false,
            isLoaded: false
        };
    },
    methods: {
        setSelectedUsers(val){
            this.selectedUsers = val;
        },
        deleteGroup() {
            this.$confirm(this.$t('willDeleteUserGroup'), this.$t('warning'), {
                confirmButtonText: this.$t('ok'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
                center: true
            }).then(() => {
                return this.axios
                    .delete(`/permission-group/${this.groupId}`)
                    .then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t('groupDeleted')
                        });
                        this.$router.push({name: 'permissions'});
                    })
                    .catch(err => {
                        this.$message({
                            type: 'error',
                            message: this.$t('groupCouldNotDeleted')
                        });
                        console.log(err);
                    });
            });
        },
        save() {
            let body = {};
            let haveAtleastOnePerm = false;
            if(this.groupType != null){
                this.groupName = _.clone(this.originalName);
            }
            body.groupName = this.groupName;
            body.permissions = {};
            _.each(Object.keys(this.permissions), group => {
                _.each(Object.keys(_.get(this.permissions,group)), permissionKey => {
                    body.permissions[permissionKey] = !!this.permissions[group][permissionKey].value;
                    haveAtleastOnePerm = haveAtleastOnePerm || !!this.permissions[group][permissionKey].value;
                });
            });
            body.users = this.selectedUsers;
            if(_.trim(body.groupName, ' ') == ''){
                this.$message({
                    type: 'error',
                    message: this.$t('mustHaveGroupName')
                });
            }
            else if(!haveAtleastOnePerm){
                this.$message({
                    type: 'error',
                    message: this.$t('leastOnePermission')
                });
            }
            else if (this.groupType === 'admin' && _.isEmpty(this.selectedUsers)) {
                this.$message({
                    type: 'error',
                    message: this.$t('leastOneUserAtAdmin')
                });
            } else if (this.groupType === 'admin' && !_.includes(this.selectedUsers,this.$store.state.user.id)) {
                this.$message({
                    type: 'error',
                    message: this.$t('cannotRemoveYourselfFromAdmin')
                });
            } else {
                return this.isEditPage ? this.updateGroup(body) : this.createGroup(body);
            }
        },
        updateGroup(body) {
            return this.axios
                .put(`/permission-group/${this.groupId}`, body)
                .then(({data}) => {
                    this.$message({
                        type: 'success',
                        message: this.$t('changesSaved')
                    });
                    this.isChanged = false;
                    return Promise.resolve(data).then(()=>
                        this.$router.push({name: 'permissions'})
                    );
                })
                .catch(err => {
                    this.$message({
                        type: 'error',
                        message: this.$t('changesCouldNotSaved')
                    });
                    console.log(err);
                });
        },
        createGroup(body) {
            return this.axios
                .post(`/permission-group`, body)
                .then(() => {//{data}
                    this.$message({
                        type: 'success',
                        message: this.$t('newUserGroupCreated')
                    });
                    this.isChanged = false;
                    this.$router.push({name: 'permissions'});
                    //this.$router.push({name: 'edit-permissions', params: {id: _.get(data,"results")}});
                })
                .catch(err => {
                    this.$message({
                        type: 'error',
                        message: this.$t('userGroupCouldNotCreated')
                    });
                    console.log(err);
                });
        },
        permissionGroupSelected(checked, group) {
            _.each(Object.keys(_.get(this.permissions, group)), permissionKey => {
                this.permissions[group][permissionKey].value = checked;
            });
        },
        permissionSelected(checked, group) {
            let inGroupOptions = Object.values(_.get(this.permissions,group));
            if (_.isEmpty(_.filter(inGroupOptions, option => !option.value))) {
                // all values are true
                this.allPermissions[group].value = true;
            } else {
                this.allPermissions[group].value = false;
            }
        },
        getPermissionConfig() {
            return this.axios
                .get(`/permission-group/${this.groupId}`)
                .then(({data}) => {
                    return Promise.resolve(data);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        init(){
            this.isEditPage = _.get(this.$store.state.route,'name') === 'edit-permissions';
            if (this.isEditPage) {
                this.groupId = this.$store.state.route.params.id;
                this.getPermissionConfig().then(permissionConfig => {
                    this.groupType = _.get(permissionConfig,'type');
                    _.each(Object.keys(this.permissions), group => {
                        _.each(Object.keys(this.permissions[group]), permission => {
                            this.permissions[group][permission].value = _.get(permissionConfig,permission);
                        });
                    });
                    this.selectedUsers = _.get(permissionConfig,'users');
                    setTimeout(() => {
                        _.each(document.getElementsByClassName('el-checkbox el-transfer-panel__item'), el => {
                            el.setAttribute('title', el.innerText);
                        });
                        this.groupName = _.get(permissionConfig,'name');
                        this.originalName =  _.clone(this.groupName);
                    });
                }, 1000);
            }
            this.isLoaded = true;
        }
    },
    created() {
        this.init();
    },
    watch: {
        'permissions.dataPermissions.canEditData.value': function(val){
            this.permissions.dataPermissions.canViewData.value = this.permissions.dataPermissions.canViewData.value || val;
            this.permissions.dataPermissions.canViewData.disabled = val;
        },
        'permissions.dataPermissions.canAddDatatype.value': function(val){
            this.permissions.dataPermissions.canViewData.value = this.permissions.dataPermissions.canViewData.value || val;
            this.permissions.dataPermissions.canViewData.disabled = val;
        },
        'permissions.auditPermissions.canStartAudits.value': function(val){
            this.permissions.auditPermissions.canReplyToAudits.value = this.permissions.auditPermissions.canReplyToAudits.value || val;
            this.permissions.auditPermissions.canReplyToAudits.disabled = val;
        },
        'permissions.targetPermissions.canCreateGlobalGoals.value': function(val){
            this.permissions.generalPermissions.isAdmin.value = this.permissions.generalPermissions.isAdmin.value || val;
            this.permissions.generalPermissions.isAdmin.disabled = val;
        },
        '$route.path': function(){
            this.init();
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.$confirm(this.$t('thereAreChanges'), this.$t('warning'), {
                confirmButtonText: this.$t('saveChanges'),
                cancelButtonText: this.$t('leaveWithoutSaving'),
                type: 'warning',
                center: true
            })
                .then(() => this.save())
                .catch(() => next());
        } else {
            next();
        }
    },
    computed: {
        allUsers() {
            let users = _.clone(_.filter(this.$store.state.users, user=>user.status == 'active'));
            _.each(users,user => {
                user.label = `${user.name} ${!_.isEmpty(user.userGroups) ? '|' : ''} ${_.join(_.map(user.userGroups, 'name'),', ')}`;
            });
            return users;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "sitesTitle": "Lokasyonlar",
            "userGroup": "User Group",
            "activeUsers": "Active Users",
            "permissions": "İzinler",
            "groupName": "Grup Adı",
            "dataPermissions": "Veri",
            "targetPermissions": "Hedef",
            "auditPermissions": "Denetim",
            "documentPermissions": "Dokümanlar",
            "generalPermissions": "Genel",
            "reportPermissions": "Excel Raporu",
            "canViewData": "Veri Görüntüleme",
            "canEditData": "Veri Düzenleme",
            "canAddDatatype": "Veri Tipi Ekleme",
            "canCreateGlobalGoals": "Global Hedef Ekleme",
            "canCreateGoals": "Hedef Ekleme",
            "canEditGoals": "Hedef Düzenleme",
            "canApproveGoals": "Hedef Onaylama",
            "canStartAudits": "Düzenleyici ve Önleyici Faaliyet Oluşturma",
            "canReplyToAudits": "Düzenleyici ve Önleyici Aksiyonlara Yanıt Verme",
            "canCreateAudit": "Denetim Kaydı Oluşturma",
            "canUploadDocuments": "Doküman Yükleme",
            "canViewComparisons": "Kıyaslama Sayfasını Görüntüleme",
            "canSeeAllLocations": "Tüm Lokasyonları Görüntüleme",
            "canGetReport": "Rapor Al",
            "isAdmin": "Admin Sayfasına Erişim",
            "users": "Kullanıcılar",
            "allUsers": "Tüm Kullanıcılar",
            "selectedUsers": "Seçili Kullanıcılar",
            "searchUsers": "Kullanıcı Ara",
            "thisGroupCanNotBeEdit": "Bu grubun ismi ve izinleri değiştirilemez.",
            "thereAreChanges":"Kaydetmediğiniz değişiklikler var, kaydetmeden çıkmak istediğinize emin misiniz ?",
            "saveChanges": "Değişiklikleri Kaydet",
            "leaveWithoutSaving":"Kaydetmeden Çık",
            "willDeleteUserGroup":"Bu kullanıcı grubu kalıcı olarak silinecek, emin misiniz ?",
            "ok":"Tamam",
            "cancel":"İptal",
            "warning":"Uyarı",
            "leastOneUserAtAdmin":"En Az Bir Kullanıcı Yönetici Olmalı",
            "leastOnePermission": "En Az Bir Kullanıcı İzni Tanımlanmalı",
            "mustHaveGroupName": "Grup İsmi Girilmeli",
            "cannotRemoveYourselfFromAdmin":"Kendinizi Yöneticiden Kaldıramazsınız",
            "changesSaved":"Değişiklikler kaydedildi",
            "changesCouldNotSaved":"Değişiklikler Kaydedilemedi",
            "newUserGroupCreated":"Yeni Kullanıcı Grubu Oluşturuldu",
            "userGroupCouldNotCreated":"Kullanıcı Grubu Oluşturulamadı",
            "groupDeleted":"Grup Silindi",
            "groupCouldNotDeleted":"Grup Silinemedi",
            "dafeultGroupSystemTranslation":"Varsayılan Grup Sistemi Çevirisi"
        },
        "en": {
            "sitesTitle": "Sites",
            "userGroup": "Kullanıcı Grubu",
            "activeUsers": "Aktif Kullanıcılar",
            "permissions": "Permissions",
            "groupName": "Group Name",
            "dataPermissions": "Data",
            "targetPermissions": "Target",
            "auditPermissions": "Audit",
            "documentPermissions": "Document",
            "generalPermissions": "General",
            "reportPermissions": "Excel Report",
            "canViewData": "View Data",
            "canEditData": "Edit Data",
            "canAddDatatype": "Add Data Types",
            "canCreateGlobalGoals": "Create Global Targets",
            "canCreateGoals": "Create Targets",
            "canEditGoals": "Edit Targets",
            "canApproveGoals": "Approve Targets",
            "canStartAudits": "start preventive/corrective actions",
            "canReplyToAudits": "reply to preventive/corrective actions",
            "canCreateAudit": "Create Audit",
            "canUploadDocuments": "Upload Documents",
            "canViewComparisons": "View Benchmarking Page",
            "canSeeAllLocations": "Viewing All Locations",
            "canGetReport": "Get Reports",
            "isAdmin": "View Admin Page",
            "users": "Users",
            "allUsers": "All Users",
            "selectedUsers": "Selected Users",
            "searchUsers": "Search Users",
            "thisGroupCanNotBeEdit": "The name and permissions of this group cannot be changed.",
            "thereAreChanges":"There are changes you did not save, are you sure you want to leave without saving ?",
            "saveChanges": "Save Changes",
            "leaveWithoutSaving":"Leave Without Saving",
            "willDeleteUserGroup":"This user group will be permanently deleted, are you sure ?",
            "ok":"Ok",
            "cancel":"Cancel",
            "warning":"Warning",
            "leastOneUserAtAdmin":"At Least One User Must Be An Admin",
            "leastOnePermission": "At least One User Permission Must Be Defined",
            "mustHaveGroupName": "Group Name Must Be Entered",
            "cannotRemoveYourselfFromAdmin":"Cannot Remove Yourself From Admin",
            "changesSaved":"Changes Saved",
            "changesCouldNotSaved":"Changes Could Not Saved",
            "newUserGroupCreated":"New User Group Created",
            "userGroupCouldNotCreated":"User Group Could Not Created",
            "groupDeleted":"Group Deleted",
            "groupCouldNotDeleted":"Group Could Not Deleted",
            "dafeultGroupSystemTranslation":"Default Group System Translation"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/PermissionEdit.vue